import type { ReactNode } from "react";
import { cn } from "@shared/lib/utils";

export type BadgeTone = "accent" | "yellow" | "rarity" | "neutral";

/** Hairline chips, tone carried by TEXT color only — accent green for
 * NEW/success, yellow for warn/RP, rarity violet where cards speak. */
const TONE_STYLES: Record<BadgeTone, string> = {
  accent: "border-line text-accent",
  yellow: "border-line text-yellow",
  rarity: "border-line text-rarity",
  neutral: "border-line text-ink-mute",
};

type BadgeProps = {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
};

/** Tiny mono uppercase status chip — BEST/HOT/NEW, "Soon", "Coming soon". */
export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border bg-white/4 px-2 py-0.5 font-mono text-[9px] font-medium uppercase tracking-[0.14em]",
        TONE_STYLES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
